import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/HeaderComponents/BreadCrum";
import CreateUserForm from "./AdminUtils/CreateUserForm";

export default function CreateUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="pb4">
      <div className="w100 flexbread">
        <div className="divbreadcrum w90">
          <BreadCrumb />
        </div>
      </div>
      <div className="container containerflex">
        <div className="w90 labeltittle">
          <h2 className="tittlecatalog">{t("createuser.title")}</h2>
        </div>

        <div className="w90 bgwhite mtb2 create-user-shell">
          <CreateUserForm
            onCancel={() => navigate("/usercontrol")}
            onSuccess={() => navigate("/usercontrol")}
          />
        </div>
      </div>
    </section>
  );
}
